export type IconProps = React.ComponentProps<'svg'>

export function DownloadIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      {...props}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6.25002 8.6665L2.91669 5.33317L3.85002 4.3665L5.58335 6.09984V0.666504H6.91669V6.09984L8.65002 4.3665L9.58335 5.33317L6.25002 8.6665ZM2.25002 11.3332C1.88335 11.3332 1.56946 11.2026 1.30835 10.9415C1.04724 10.6804 0.916687 10.3665 0.916687 9.99984V7.99984H2.25002V9.99984H10.25V7.99984H11.5834V9.99984C11.5834 10.3665 11.4528 10.6804 11.1917 10.9415C10.9306 11.2026 10.6167 11.3332 10.25 11.3332H2.25002Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ThumbUpIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7947 5.66708C14.1118 5.66708 14.3919 5.78867 14.6351 6.03183C14.8782 6.27499 14.9998 6.55512 14.9998 6.87222V7.94912C14.9998 8.01908 14.9908 8.09406 14.9729 8.17403C14.9549 8.254 14.9348 8.3286 14.9126 8.39783L13.0021 12.9063C12.9065 13.1194 12.7464 13.2995 12.5216 13.4465C12.2968 13.5935 12.0623 13.667 11.818 13.667H4.80752V5.66708L8.68572 1.82223C8.8182 1.68975 8.97162 1.61069 9.14597 1.58505C9.32033 1.55941 9.48742 1.58932 9.64724 1.6748C9.80706 1.76027 9.92415 1.88163 9.9985 2.03888C10.0729 2.19615 10.0887 2.35897 10.0459 2.52733L9.328 5.66708H13.7947ZM5.8075 6.09272V12.6671H11.8203C11.8673 12.6671 11.9154 12.6542 11.9646 12.6286C12.0137 12.603 12.0511 12.5602 12.0768 12.5004L13.9998 8.0004V6.87222C13.9998 6.81238 13.9806 6.76323 13.9421 6.72477C13.9037 6.6863 13.8545 6.66707 13.7947 6.66707H8.06392L8.89982 3.01322L5.8075 6.09272ZM2.87164 13.667C2.54023 13.667 2.25652 13.549 2.02052 13.313C1.78451 13.077 1.6665 12.7933 1.6665 12.4619V6.87222C1.6665 6.54081 1.78451 6.2571 2.02052 6.0211C2.25652 5.78509 2.54023 5.66708 2.87164 5.66708H4.80752V6.66707H2.87164C2.8118 6.66707 2.76265 6.6863 2.72419 6.72477C2.68572 6.76323 2.66649 6.81238 2.66649 6.87222V12.4619C2.66649 12.5218 2.68572 12.5709 2.72419 12.6094C2.76265 12.6478 2.8118 12.6671 2.87164 12.6671H4.80752V13.667H2.87164Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function StarCircleTipIcon(props: IconProps) {
  return (
    <svg
      width="25"
      height="24"
      {...props}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_3835_11371" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3835_11371)">
        <path
          d="M18.5 7V5.5H21.5V4.5H18.5V1H23V2.5H20V3.5H22C22.2833 3.5 22.5208 3.59583 22.7125 3.7875C22.9042 3.97917 23 4.21667 23 4.5V6C23 6.28333 22.9042 6.52083 22.7125 6.7125C22.5208 6.90417 22.2833 7 22 7H18.5Z"
          fill="currentColor"
        />
        <path
          d="M12.5 22C11.1167 22 9.81667 21.7375 8.6 21.2125C7.38333 20.6875 6.325 19.975 5.425 19.075C4.525 18.175 3.8125 17.1167 3.2875 15.9C2.7625 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.7625 9.31667 3.2875 8.1C3.8125 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.3125 8.6 2.7875C9.81667 2.2625 11.1167 2 12.5 2C13.2167 2 13.9083 2.07083 14.575 2.2125C15.2417 2.35417 15.8833 2.55833 16.5 2.825V5.075C15.9167 4.74167 15.2875 4.47917 14.6125 4.2875C13.9375 4.09583 13.2333 4 12.5 4C10.2833 4 8.39583 4.77917 6.8375 6.3375C5.27917 7.89583 4.5 9.78333 4.5 12C4.5 14.2167 5.27917 16.1042 6.8375 17.6625C8.39583 19.2208 10.2833 20 12.5 20C14.7167 20 16.6042 19.2208 18.1625 17.6625C19.7208 16.1042 20.5 14.2167 20.5 12C20.5 11.4667 20.4458 10.95 20.3375 10.45C20.2292 9.95 20.0833 9.46667 19.9 9H22.05C22.2 9.48333 22.3125 9.97083 22.3875 10.4625C22.4625 10.9542 22.5 11.4667 22.5 12C22.5 13.3833 22.2375 14.6833 21.7125 15.9C21.1875 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6875 16.4 21.2125C15.1833 21.7375 13.8833 22 12.5 22Z"
          fill="currentColor"
        />
        <path
          d="M8.5 18L12.5 14.95L16.5 18L15 13.05L19 10.2H14.1L12.5 5L10.9 10.2H6L10 13.05L8.5 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CoinIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4887_3921)">
        <path
          d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9941 8.78881 19.7682 7.58877 19.3333 6.45833C18.6155 4.56277 17.3385 2.93011 15.6717 1.77674C14.0049 0.62337 12.0269 0.00374911 10 0Z"
          fill="#F9A050"
        />
        <path
          d="M10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C8.01088 2.5 6.10322 3.29018 4.6967 4.6967C3.29018 6.10322 2.5 8.01088 2.5 10C2.5 11.9891 3.29018 13.8968 4.6967 15.3033C6.10322 16.7098 8.01088 17.5 10 17.5Z"
          fill="#FFDA70"
        />
        <path
          d="M17.75 7.08294C17.75 7.08294 17.8333 6.99961 17.875 7.08294C17.875 7.08294 17.7917 7.16628 17.75 7.08294ZM17.0833 6.08294L16.875 5.99961L17.0417 6.08294H17.0833ZM16.75 5.66628V5.70794H16.9167L16.4167 5.16628C16.2917 5.33294 16.6667 5.45794 16.75 5.66628ZM16.375 4.49961L16.3333 4.37461C16.2917 4.45794 16.1667 4.37461 16.4167 4.49961H16.375ZM16.375 4.49961C16.375 4.37461 16.4583 4.58294 16.375 4.49961V4.49961ZM16.125 4.16628C16.125 4.16628 16.0417 3.99961 16.125 4.04128C15.9583 3.95794 15.9583 3.99961 15.9583 4.12461L16.125 4.16628ZM15.9167 4.16628C15.875 4.20794 15.9167 4.16628 16 4.20794L15.8333 4.16628C15.8333 4.20794 15.7917 4.29128 15.9167 4.20794V4.16628ZM16 4.45794C16.125 4.54128 16.1667 4.58294 16.2083 4.54128C16.2083 4.49961 16.2083 4.41628 16.0417 4.29128C16.0833 4.41628 16.1667 4.49961 16 4.45794ZM16.25 5.41628L16.1667 5.29128C16.1667 5.24961 16.1667 5.20794 16.125 5.24961V5.37461H16.25V5.41628ZM15.1667 3.33294C15.125 3.41628 15.1667 3.49961 15.0833 3.54128H15.2083C15.2083 3.54128 15.125 3.41628 15.1667 3.37461V3.33294ZM15.0833 3.54128L14.9167 3.49961C15.0417 3.58294 15.0833 3.58294 15.0833 3.49961V3.54128ZM15.7917 4.37461L15.4583 4.20794V4.24961L15.7917 4.33294V4.37461ZM14.75 2.91628L14.5417 2.95794H14.75V2.91628ZM14.2083 2.70794C14.3333 2.70794 14.2083 2.54128 14.2917 2.54128H13.9167C14.0417 2.54128 14.125 2.62461 14.2083 2.70794ZM14.6667 3.12461V3.24961L14.75 3.29128L14.6667 3.12461ZM15.0417 3.99961C15.125 3.99961 15.0417 3.83294 15.25 3.87461C15.125 3.87461 14.9167 3.79128 15.0417 3.99961ZM14.9583 3.49961H14.75L14.875 3.58294C14.875 3.58294 14.875 3.49961 14.9583 3.49961ZM14.625 3.45794H14.75L14.6667 3.41628L14.625 3.45794ZM13.9583 2.79128C13.875 2.79128 13.7917 2.79128 13.7083 2.70794L13.9583 2.91628C14 2.91628 14.0833 2.83294 13.9583 2.79128ZM13.9583 2.91628C13.9842 2.94544 14.0165 2.96816 14.0526 2.98263C14.0888 2.9971 14.1278 3.00291 14.1667 2.99961C14.0938 2.98135 14.0237 2.95332 13.9583 2.91628ZM13.4583 2.49961L13.5417 2.58294L13.4583 2.45794V2.49961ZM14.2917 2.95794H14.1667L14.2917 2.99961V2.95794ZM12.0833 2.91628H12.2917C12.2917 2.91628 12.1667 2.95794 12.2083 2.99961C12.25 2.91628 12.5 2.87461 12.625 3.04128C12.7917 3.04128 12.8333 2.62461 12.75 2.41628C12.75 2.45794 12.7083 2.49961 12.5 2.49961C12.5833 2.58294 12.875 2.74961 12.6667 2.79128L12.4583 2.74961C12.4583 2.70794 12.4583 2.66628 12.375 2.62461C12.4583 2.74961 12.0833 2.70794 12.0833 2.91628ZM13.0833 2.54128H13.1667C13.0833 2.54128 13.0417 2.45794 12.9583 2.33294L12.75 2.37461L13.0833 2.54128ZM13.25 2.91628C13.4583 2.99961 13.4167 2.91628 13.5417 2.91628C13.25 2.74961 13.6667 2.87461 13.4583 2.70794L13.6667 2.74961L13.5 2.62461V2.66628L13.1667 2.58294L13.5 2.70794C13.375 2.74961 13.1667 2.74961 13.25 2.91628ZM14.7083 4.08294C14.6667 4.08294 14.6667 4.08294 14.7083 4.08294V4.08294ZM14.7917 3.99961L14.625 3.66628V3.95794L14.75 3.99961C14.7917 4.08294 14.75 4.04128 14.7083 4.08294C14.7083 4.08294 14.875 4.12461 14.7917 3.99961ZM13.9167 3.33294C14.0833 3.45794 14.0833 3.33294 14.0833 3.33294C13.9893 3.2951 13.8915 3.26717 13.7917 3.24961L13.9167 3.37461V3.33294ZM12.8333 2.16628L12.625 2.29128H12.7917L12.8333 2.16628ZM12.4167 2.08294H12.2917L12.375 2.16628L12.4167 2.08294ZM3.625 5.08294C3.5 5.12461 3.25 5.16628 3.375 5.20794L3.5 5.24961C3.52279 5.18213 3.5666 5.12372 3.625 5.08294ZM2.79167 11.3329V11.2496L2.66667 11.2079L2.75 11.2913L2.79167 11.3329ZM8.58333 16.5829L8.66667 16.4996C8.54167 16.4996 8.58333 16.5413 8.58333 16.5829ZM8.33333 2.12461H8.04167C8.20833 2.12461 8.33333 2.20794 8.33333 2.12461ZM4.875 16.2913H5C4.95833 16.2079 4.91667 16.2079 4.875 16.2913ZM7.75 2.20794H7.79167L8.04167 2.08294C7.95833 2.08294 7.83333 2.08294 7.75 2.20794ZM18 8.37461L17.9583 8.20794V8.37461H18ZM11.1667 2.33294L11.125 2.37461V2.33294H11.1667ZM7.20833 3.16628C7.25 3.16628 7.25 3.16628 7.20833 3.16628V3.16628ZM10.9583 1.91628L10.8333 1.83294C10.8552 1.8661 10.8835 1.89446 10.9167 1.91628H10.9583ZM10.7917 1.83294H10.6667H10.8333H10.7917ZM13.5417 16.3329C13.5833 16.2496 13.5833 16.3329 13.5417 16.3329V16.3329ZM3.75 7.74961C3.625 7.58294 3.66667 7.54128 3.75 7.45794L3.375 7.41628L3.70833 7.74961H3.75ZM17.9167 11.7496C17.9167 11.7913 17.9583 11.7496 18 11.7496C17.8333 11.9163 18.0417 11.9579 18.0417 12.0829L17.75 12.3329C17.75 12.4579 17.875 12.3746 17.9167 12.4163C17.875 12.6663 17.7083 12.9163 17.5833 13.1663C17.5494 13.2185 17.5215 13.2744 17.5 13.3329L17.4167 13.4996L17.2917 13.8329C17.1667 13.9163 17.125 13.7079 17.0417 13.8746C17.2083 13.8329 17.1667 13.9579 17.0833 14.0829C17.0417 14.2496 16.9583 14.3746 17.0833 14.3746C16.9167 14.3746 16.8333 14.4996 16.7083 14.5829C16.625 14.7079 16.5417 14.7496 16.375 14.5829C16.25 14.7496 16.375 14.8329 16.4583 14.8329L16.25 15.0829C16.214 15.134 16.186 15.1902 16.1667 15.2496L16.125 15.4163C16.0417 15.4163 15.875 15.6663 15.625 15.8746C15.375 16.0829 15.125 16.2913 14.9583 16.2496C15.2083 16.2913 15 16.3329 14.9583 16.4579L15.125 16.4996L14.8333 16.7079L14.75 16.7496C14.7083 16.7913 14.75 16.6663 14.5833 16.7496L14.4167 16.8746L14.3333 17.0413H14.375L14.25 17.1246C14.125 17.1663 14.5417 16.7913 14.1667 16.9163C14.1667 16.9163 14.0833 17.2496 13.9167 17.2079C14.125 17.1246 14.0417 17.0413 13.9167 17.0413L13.7083 17.1663L13.875 17.2913C13.1667 17.6246 12.3333 17.7913 11.5 17.9579C11.5 17.7496 10.9167 17.9996 10.9583 17.7496H11C11.2083 17.7079 10.9167 17.5829 10.75 17.5829C10.9167 17.6663 10.4583 17.8746 10.9167 17.8746L10.5833 18.0413C10.5 18.2496 10.2917 18.2496 10.0417 18.2079L9.625 18.1246C9.48835 18.0893 9.34498 18.0893 9.20833 18.1246L9.25 18.0413H8.91667L8.58333 17.9579C8.375 17.8746 8.25 17.7496 8.16667 17.7913V17.6663C7.75 17.7496 7.70833 17.7496 7.33333 17.4996C7.33333 17.4996 7.375 17.4996 7.33333 17.4163L7.125 17.4579C7.04167 17.4579 6.91667 17.4579 6.79167 17.3746L6.375 17.1246C6.41667 17.0413 6.375 16.9996 6.33333 16.9579C6.23991 16.9079 6.14232 16.8661 6.04167 16.8329C5.79167 16.7913 5.58333 16.7079 5.625 16.4579C5.5 16.4996 5.20833 16.3329 5 16.2913V16.2079C4.875 16.2079 4.79167 16.1246 4.70833 15.9996L4.5 15.6663C4.375 15.6246 4.375 15.7079 4.33333 15.7913C4.33333 15.6246 4.16667 15.5413 4 15.4579L3.70833 15.2496C3.58333 15.0829 3.79167 15.0829 3.83333 14.9996C3.625 14.7913 3.54167 15.2496 3.41667 14.8329L3.54167 14.8746L3.58333 14.4996V14.2079V14.3329C3.41667 14.2496 3.41667 14.0413 3.41667 13.9163C3.41667 13.7913 3.41667 13.6663 3.29167 13.7079L3.16667 13.7913C3.1745 13.7081 3.1745 13.6244 3.16667 13.5413L3.08333 13.4579C3.04167 13.4579 3 13.3746 2.95833 13.1246C2.875 12.9579 2.95833 12.8329 2.75 12.7913V12.8329L2.625 12.3329C2.58333 12.3329 2.5 12.2079 2.54167 12.1663C2.375 12.1663 2.33333 11.5829 2.33333 11.4579C2.375 11.6663 2.45833 11.5413 2.5 11.4579L2.33333 11.3746L2.375 11.1663C2.16667 11.1663 1.95833 11.1663 1.875 10.7913C1.875 10.8746 1.95833 10.9579 1.95833 10.8746V10.7496C1.95833 10.7496 2.04167 10.8329 2.08333 10.7496C1.875 10.5829 2.08333 10.3746 1.95833 10.0413C2.04167 10.1663 2.08333 10.0413 2.16667 10.0413C2.04167 10.0413 2.08333 9.91628 2.16667 9.79128C2.16667 9.70794 2.20833 9.66628 2.08333 9.70794L2.29167 8.62461C2.29167 8.45794 2.33333 8.29128 2.41667 8.20794C2.45833 8.04128 2.5 7.95794 2.58333 7.91628C2.66667 7.87461 2.58333 7.66628 2.58333 7.54128L2.70833 7.58294C2.625 7.24961 2.70833 7.37461 2.70833 6.95794C2.75 7.12461 2.83333 7.08294 2.95833 6.99961L2.875 6.66628L3.04167 6.70794C3.04167 6.58294 3.125 6.49961 3.16667 6.41628C3.16667 6.45794 3.16667 6.41628 3.20833 6.41628C3.125 6.37461 3.125 6.24961 3.16667 6.12461L3.25 5.79128C3.5 5.79128 3.33333 5.49961 3.58333 5.54128V5.41628C3.45833 5.41628 3.375 5.33294 3.45833 5.29128H3.625L3.75 5.04128L3.625 5.08294L3.79167 5.04128V4.99961C3.83333 4.99961 3.91667 4.95794 3.91667 4.83294C4.125 4.74961 4.20833 4.58294 4.33333 4.37461L4.45833 4.08294L4.75 3.95794L4.625 4.08294C4.875 3.83294 5.25 3.79128 5.375 3.58294L5.29167 3.49961C5.45833 3.29128 5.58333 3.16628 5.75 3.08294V2.91628L6.25 2.58294C6.33485 2.51688 6.43531 2.47382 6.54167 2.45794H6.79167C6.79167 2.37461 7.16667 2.37461 7.33333 2.29128L7.375 2.37461C7.625 2.33294 7.70833 2.24961 7.79167 2.16628C8.08333 2.16628 8.29167 2.16628 8.45833 2.08294C8.66667 2.04128 8.875 1.91628 9.04167 1.91628V1.95794L9.41667 1.83294C9.33333 1.95794 9.45833 1.79128 9.58333 1.79128C9.70833 1.70794 9.91667 1.74961 10.0833 1.79128H10.3333C10.0417 1.87461 10.3333 1.95794 10.3333 2.08294L10.5417 1.99961C10.5417 2.08294 10.4167 2.08294 10.5417 2.12461C10.625 2.08294 10.9583 2.12461 11.0417 1.99961C11.0225 1.96439 10.9936 1.93545 10.9583 1.91628L11 1.83294C11.2083 1.91628 11.125 1.83294 11.125 1.79128L11.4167 1.95794C11.4583 1.95794 11.5417 1.99961 11.5833 2.12461C11.4167 1.83294 12.0833 2.20794 12 1.95794C12.125 2.20794 12.125 1.99961 12.1667 2.20794C11.9583 2.08294 11.7083 2.20794 11.5 2.24961L11.6667 2.41628C11.5 2.58294 11.2917 2.24961 11.1667 2.29128L11.4167 2.37461V2.20794C11.3483 2.1903 11.2767 2.1903 11.2083 2.20794C11.1531 2.19997 11.0969 2.19997 11.0417 2.20794L10.7083 2.29128C10.875 2.37461 10.5417 2.37461 10.625 2.49961H10.75C10.8333 2.54128 10.7083 2.58294 10.625 2.62461C10.2083 2.49961 9.45833 2.62461 9.29167 2.49961C9.375 2.54128 9.54167 2.49961 9.625 2.41628H9.41667H9.91667C9.83333 2.33294 10 2.16628 9.83333 1.99961C9.58333 1.95794 9.5 1.99961 9.41667 2.12461C9.29167 2.24961 9.20833 2.33294 8.91667 2.37461C8.875 2.37461 9 2.16628 8.75 2.29128C8.375 2.45794 8.16667 2.74961 8.25 2.95794C8.375 2.87461 8.625 2.66628 8.70833 2.83294C8.58333 2.95794 8.33333 3.04128 8.375 3.12461C8.16667 2.95794 8.625 2.99961 8.375 2.91628C8.29167 2.91628 8.25 2.99961 8.25 3.04128C8.25 2.95794 8.125 2.95794 8.04167 2.91628C7.90598 2.95818 7.76637 2.98611 7.625 2.99961H7.41667L7.16667 3.12461C7.16667 3.12461 7.08333 3.08294 7.08333 2.99961C6.91667 3.12461 6.83333 3.49961 6.95833 3.58294C6.79167 3.66628 6.70833 3.58294 6.58333 3.74961C6.91667 3.74961 6.54167 3.74961 6.58333 3.91628C6.45833 3.99961 6.5 3.83294 6.41667 3.83294V4.04128C6.20833 3.95794 6.41667 3.62461 6.20833 3.54128C6.08436 3.51859 5.9573 3.51859 5.83333 3.54128H5.58333C5.58333 3.74961 6 4.24961 6.20833 4.37461C6.29167 4.45794 6.04167 4.37461 5.95833 4.37461C5.83333 4.37461 5.79167 4.45794 5.75 4.54128C5.75 4.62461 5.70833 4.70794 5.625 4.74961V4.58294L5.41667 4.83294C5.41667 4.83294 5.33333 4.54128 5.20833 4.54128C5.14122 4.58392 5.08432 4.64083 5.04167 4.70794V4.95794C5.04167 5.12461 5.04167 5.24961 5.125 5.29128L5.33333 4.83294V5.04128C5.29167 5.12461 5.25 5.24961 5.33333 5.29128L5 5.58294C5 5.54128 5.125 5.37461 5 5.37461C4.875 5.49961 4.91667 5.37461 4.79167 5.45794L4.75 4.83294L4.66667 4.24961C4.61807 4.3293 4.57626 4.41292 4.54167 4.49961C4.45833 4.66628 4.45833 4.91628 4.54167 5.12461C4.54167 5.29128 4.66667 5.54128 4.70833 5.58294C4.54167 5.70794 4.33333 5.45794 4.29167 5.37461C4.08333 5.66628 4.45833 5.91628 4.29167 6.20794L4.375 6.12461L4.20833 6.45794C4.125 6.45794 3.875 6.41628 3.875 6.29128L4 6.70794L3.70833 6.54128C3.66667 6.66628 3.875 6.87461 3.95833 6.83294L3.54167 7.04128C3.5 7.08294 3.79167 7.12461 3.83333 7.08294C3.83333 7.24961 3.75 7.33294 3.70833 7.41628C3.70833 7.12461 3.20833 7.12461 3 6.99961L3.54167 7.83294L3.25 7.62461C3.33333 7.70794 3.375 7.91628 3.33333 8.12461L3.25 8.41628L3.20833 8.70794C3.125 8.58294 3 8.87461 3.08333 8.99961V8.87461C2.83333 9.08294 3.375 9.20794 3.125 9.37461C3.16667 9.20794 3.125 9.16628 3 9.16628C3.08333 9.33294 2.95833 9.70794 3.20833 9.62461C3.16667 9.74961 3.20833 9.83294 3.04167 9.83294L3.20833 10.2496C3.20833 10.1663 3.125 10.1663 3.08333 10.2496C3.125 10.0413 2.875 9.83294 3.08333 9.70794C2.875 9.70794 2.79167 9.79128 2.66667 9.66628C2.66667 9.91628 2.79167 10.0829 2.91667 10.2496L3.08333 10.4579L3.25 10.6246L3.16667 11.0413H3.25L3.08333 11.1246L3.16667 11.2079H3.08333L3.16667 11.2913C3.04167 11.2913 2.91667 11.2913 2.79167 11.2079L2.91667 11.0829C2.79167 11.0413 2.70833 10.9996 2.625 11.0829L2.70833 11.1663C2.625 11.1246 2.54167 11.0829 2.5 11.1663L2.66667 11.4163L2.79167 11.2496C2.95833 11.4163 3.125 11.6246 3.20833 11.4163V11.6663L3.625 12.0829L3.41667 12.1246C3.58333 12.2079 3.54167 12.3746 3.54167 12.4996C3.54167 12.6246 3.5 12.7496 3.58333 12.7496C3.70833 12.8746 3.79167 12.7496 3.875 12.8329C3.875 12.8329 3.79167 12.8329 3.83333 12.8746L4 12.9579C4 12.9996 3.875 12.8746 3.875 13.0413L4.125 13.2913L4.25 13.5413C4.45833 13.8329 4.45833 13.2913 4.54167 13.5413C4.45833 13.6663 4.375 13.7496 4.45833 13.8746C4.58333 13.9163 4.66667 13.8746 4.75 13.9579L4.625 14.0413C4.70833 14.1246 4.79167 14.2079 4.66667 14.2913C4.83333 14.3329 4.83333 14.4163 4.875 14.4579C5.08333 14.5829 5.04167 14.1246 5.04167 14.0413C5.08333 14.2913 5.25 14.3329 5.125 14.5829L5 14.4579C5.04167 14.7079 5.125 14.7079 5.20833 14.7496C5.29167 14.7496 5.33333 14.7496 5.25 14.9579C5.20074 14.919 5.14401 14.8907 5.08333 14.8746L4.95833 14.9163L5.16667 14.9996C5.16667 15.0413 5.08333 14.9579 5.125 15.0413H5.41667L5.66667 15.2913C5.625 15.2496 5.54167 15.2913 5.625 15.2913L5.83333 15.4163C5.75 15.4163 5.79167 15.4996 5.83333 15.5829C6.04167 15.7913 6.25 15.4163 6.33333 15.6663H6.29167V15.7496C6.45833 15.5829 6.58333 15.7079 6.70833 15.7496C6.875 15.8746 7.04167 15.9163 7.125 15.7496C7.20833 15.9579 7.125 15.8329 6.83333 15.8746L6.95833 16.0829L6.75 15.9996C6.875 16.2496 7.16667 16.1663 7.33333 16.1246C7.375 16.2079 7.125 16.3746 7.41667 16.4163C7.75 16.4579 7.41667 16.1246 7.66667 16.1663L7.75 16.4163H7.95833L8.125 16.4579L8.41667 16.6246H8.54167C8.75 16.7496 9.04167 16.4996 9.20833 16.6246L9.33333 16.7496L9.66667 16.6663C9.5 16.7079 9.5 16.8329 9.5 16.9579L9.70833 16.8746C9.70833 16.8746 9.625 16.9579 9.70833 16.9996L9.875 16.9163L10.0417 16.8329H10C10.0833 16.8329 10.2917 16.7496 10.4167 16.8329L10.3333 16.9579C10.25 16.8329 10.1667 16.9579 10.125 16.9996C10.375 16.9996 10.1667 17.0413 10.2917 17.1246C10.4583 17.1246 10.5417 16.9579 10.5 16.8746H10.7083C10.7917 16.8746 10.8333 16.8746 10.9167 16.7913V16.9579L11.0833 16.8746L10.9583 17.0829C11.1667 17.0829 11.1667 17.0413 11.1667 16.9579L11.2083 16.8746H11.4167V16.9996C11.5833 16.9163 11.5833 16.6663 11.7083 16.7913C11.8333 16.7079 11.4583 16.6663 11.75 16.5829L12.0833 16.6663C12.1667 16.5413 11.9583 16.5413 11.875 16.5413C12.3333 16.3329 12.2917 16.9163 12.7083 16.5413C12.625 16.5413 12.625 16.4996 12.5833 16.4579C12.5833 16.3746 12.5833 16.3746 12.375 16.4579C12.5 16.2913 12.7917 16.4579 12.875 16.2496V16.4579L12.9583 16.3329L13 16.4579C13.0833 16.2913 13.1667 16.2913 13.2917 16.2496C13.375 16.2496 13.4583 16.2079 13.4167 16.0413C13.4583 16.2913 13.5833 15.9579 13.7083 15.9579C13.625 16.2079 13.25 16.2496 13.2917 16.4579C13.4167 16.4579 13.4167 16.3329 13.5417 16.3329L13.4583 16.5413C13.7917 16.4996 13.8333 16.1663 13.9167 16.0413L13.6667 16.2496C13.5833 16.0413 13.7917 16.1663 13.7917 15.9579H13.9167L13.9583 15.8746L14.125 15.7496L14.0833 15.7913C14.3333 15.5829 14.6667 15.8329 14.75 15.7496C14.875 15.6663 15 15.3746 14.875 15.3746C14.9167 15.2913 14.5833 15.7913 14.5417 15.3746C14.7083 15.4996 14.7917 15.3746 14.8333 15.2496L15 15.0829C15 14.9996 15.0833 14.9579 15.2083 14.9163C15.2083 15.1246 15.4167 14.9579 15.375 15.1246C15.5 14.9579 15.4583 14.9163 15.4583 14.7913H15.5833C15.5833 14.4579 15.4583 14.6246 15.625 14.2496C15.625 14.4163 15.875 14.2496 15.8333 14.3329C15.9167 14.2496 15.9583 14.1246 15.9583 14.0413L16.1667 13.7496C16.2083 13.7496 16.25 13.7496 16.25 13.6663L16.3333 13.4579H16.25L16.375 13.0413L16.4583 12.8746L16.5417 12.7079L16.6667 12.2913L16.75 11.9579L16.6667 12.0829C16.7083 12.0829 16.6667 11.7496 16.7917 11.6663V11.7496C16.8414 11.7635 16.8945 11.7584 16.9407 11.7353C16.9869 11.7122 17.0229 11.6727 17.0417 11.6246L16.9167 11.5413H17.0417C17.0417 11.3329 16.875 11.5413 16.9167 11.3746C17.0417 11.3746 17.125 11.1246 17.125 10.9579C17.125 10.7496 17.1667 10.5413 17.3333 10.4579C17.125 10.2913 17.25 10.7913 17.0833 10.6246C17.125 10.6246 17.1667 10.5829 17.2083 10.4579H17.0417L17.125 10.1246L17.1667 9.83294V9.20794C17.2083 9.04128 17.1667 8.95794 17.0417 8.87461C17.125 8.87461 17.1667 8.95794 17.2083 8.87461C17 8.79128 17.0417 8.58294 17.0833 8.45794L17.125 8.20794C17.125 8.16628 17.125 8.12461 17.0417 8.08294C17.2917 8.04128 17.375 7.54128 17.625 7.66628L17.5833 7.54128C17.75 7.54128 17.7083 7.95794 17.9167 7.95794L17.8333 8.49961C17.9167 8.45794 18 8.49961 18 8.41628C18.0417 8.54128 18.0833 8.62461 18.125 8.45794V8.87461L18.0833 9.29128V10.1246C18.1667 10.6246 18.0833 11.1663 17.9167 11.7079V11.7496ZM2.91667 11.0413C2.91667 10.9579 2.95833 10.8746 2.91667 10.8746C2.90046 10.929 2.90046 10.9869 2.91667 11.0413ZM9.875 1.91628C9.70833 1.87461 9.79167 1.91628 9.875 1.91628V1.91628ZM5 14.6663C5 14.5413 4.875 14.5413 4.83333 14.5413C4.83333 14.6246 4.83333 14.7079 5 14.6663ZM14.6667 16.6663H14.75C14.75 16.5829 14.75 16.5829 14.6667 16.6663ZM3.20833 11.2913L3.125 11.3329H3.20833V11.2913ZM11.6667 1.91628H11.4583L11.625 1.95794V1.91628H11.6667ZM12.9167 3.12461H12.9583V3.08294C12.875 2.99961 12.7917 3.04128 12.875 3.08294L12.9167 3.12461ZM11.9167 2.45794C12 2.33294 11.875 2.33294 11.7083 2.33294C11.7083 2.45794 11.8333 2.41628 11.9583 2.45794H11.9167ZM12 2.45794L12.0833 2.49961C12.0833 2.41628 12.0833 2.49961 12 2.49961V2.45794ZM10.4583 1.91628C10.5417 1.91628 10.5417 1.74961 10.5417 1.83294C10.625 1.66628 10.125 1.95794 10.4583 1.91628ZM11.6667 2.70794H11.7917V2.62461L11.6667 2.70794ZM11.2917 2.49961H11.125H11.25H11.2917ZM11.5417 2.70794H11.4583L11.3333 2.66628L11.5417 2.70794ZM8.83333 2.54128L8.625 2.62461C8.625 2.66628 8.70833 2.70794 8.75 2.62461C8.79167 2.62461 8.875 2.58294 8.83333 2.54128ZM9.41667 2.91628L9.5 2.83294C9.41667 2.83294 9.41667 2.79128 9.375 2.74961V2.91628H9.41667ZM8.91667 3.08294C8.91667 2.99961 9.125 2.95794 8.91667 2.91628C8.91667 2.99961 8.66667 3.12461 8.91667 3.08294ZM6.04167 3.83294H6.08333L5.91667 3.58294L6.04167 3.83294ZM4.75 5.83294C4.75 5.74961 4.58333 5.91628 4.54167 5.83294C4.54167 5.99961 4.45833 6.04128 4.66667 6.08294C4.83333 5.95794 4.54167 5.95794 4.75 5.83294ZM17.9167 7.58294V7.37461L17.875 7.54128L17.9167 7.58294ZM17.625 7.33294L17.7917 7.24961L17.5833 7.20794C17.625 7.20794 17.6667 7.29128 17.625 7.33294ZM6.125 15.4163L6.04167 15.5829L6.125 15.4579V15.4163ZM7.58333 16.0413C7.5 16.0413 7.41667 16.0413 7.375 15.9579C7.5 16.0413 7.5 16.2496 7.58333 16.0413Z"
          fill="#FFDF82"
        />
        <path
          d="M6 14.2079L6.125 13.6662L6.45833 11.6246C6.5 11.4579 6.45833 11.2496 6.29167 11.1662L5.08333 9.99956L4.5 9.41622C4.25 9.16622 4.16667 8.79122 4.25 8.45789C4.375 8.12456 4.66667 7.87456 5 7.83289L7.16667 7.49956L7.5 7.45789C7.66667 7.45789 7.875 7.29122 7.91667 7.12456C8.29167 6.41622 8.625 5.62456 9.04167 4.91622C9.15002 4.69274 9.3409 4.52005 9.57408 4.43455C9.80726 4.34905 10.0645 4.35742 10.2917 4.45789C10.4167 4.54122 10.5833 4.66622 10.6667 4.87456L11.25 6.08289L11.7917 7.12456C11.875 7.29122 12.0417 7.41622 12.2083 7.41622L14.6667 7.79122C14.8667 7.81292 15.0549 7.89703 15.2045 8.03165C15.354 8.16627 15.4574 8.34455 15.5 8.54122C15.5306 8.68997 15.5238 8.84398 15.4802 8.98944C15.4365 9.1349 15.3574 9.26723 15.25 9.37456L14.2917 10.2912L13.4583 11.1246C13.3937 11.1709 13.3436 11.2347 13.3141 11.3085C13.2846 11.3824 13.2768 11.4631 13.2917 11.5412C13.4501 12.413 13.5891 13.2882 13.7083 14.1662C13.7244 14.3303 13.6939 14.4955 13.6201 14.643C13.5464 14.7904 13.4326 14.914 13.2917 14.9996C13.1681 15.0936 13.0207 15.1512 12.866 15.166C12.7114 15.1807 12.5558 15.1519 12.4167 15.0829L10.125 13.8746C10.0478 13.8344 9.96204 13.8134 9.875 13.8134C9.78797 13.8134 9.70221 13.8344 9.625 13.8746L7.375 15.0829C7.15288 15.1864 6.89953 15.201 6.66703 15.1235C6.43454 15.046 6.24057 14.8823 6.125 14.6662C6.04167 14.5412 6 14.3746 6 14.2496V14.2079Z"
          fill="#F9A050"
        />
      </g>
      <defs>
        <clipPath id="clip0_4887_3921">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function AddBookMarkIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="18"
      {...props}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 17.5829V2.64071C0.5 2.13558 0.675 1.70801 1.025 1.35801C1.375 1.00801 1.80257 0.833008 2.3077 0.833008H7.99997V2.33298H2.3077C2.23077 2.33298 2.16024 2.36503 2.09613 2.42913C2.03202 2.49325 1.99997 2.56378 1.99997 2.64071V15.283L6.99997 13.133L12 15.283V8.33298H13.5V17.5829L6.99997 14.7945L0.5 17.5829ZM12 6.33298V4.33298H9.99998V2.83301H12V0.833008H13.5V2.83301H15.5V4.33298H13.5V6.33298H12Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function BookMarkIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 20.2499V5.3077C5.5 4.80257 5.675 4.375 6.025 4.025C6.375 3.675 6.80257 3.5 7.3077 3.5H16.6922C17.1974 3.5 17.625 3.675 17.975 4.025C18.325 4.375 18.5 4.80257 18.5 5.3077V20.2499L12 17.4615L5.5 20.2499Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ShareIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 22C16.1667 22 15.4583 21.7083 14.875 21.125C14.2917 20.5417 14 19.8333 14 19C14 18.8833 14.0083 18.7625 14.025 18.6375C14.0417 18.5125 14.0667 18.4 14.1 18.3L7.05 14.2C6.76667 14.45 6.45 14.6458 6.1 14.7875C5.75 14.9292 5.38333 15 5 15C4.16667 15 3.45833 14.7083 2.875 14.125C2.29167 13.5417 2 12.8333 2 12C2 11.1667 2.29167 10.4583 2.875 9.875C3.45833 9.29167 4.16667 9 5 9C5.38333 9 5.75 9.07083 6.1 9.2125C6.45 9.35417 6.76667 9.55 7.05 9.8L14.1 5.7C14.0667 5.6 14.0417 5.4875 14.025 5.3625C14.0083 5.2375 14 5.11667 14 5C14 4.16667 14.2917 3.45833 14.875 2.875C15.4583 2.29167 16.1667 2 17 2C17.8333 2 18.5417 2.29167 19.125 2.875C19.7083 3.45833 20 4.16667 20 5C20 5.83333 19.7083 6.54167 19.125 7.125C18.5417 7.70833 17.8333 8 17 8C16.6167 8 16.25 7.92917 15.9 7.7875C15.55 7.64583 15.2333 7.45 14.95 7.2L7.9 11.3C7.93333 11.4 7.95833 11.5125 7.975 11.6375C7.99167 11.7625 8 11.8833 8 12C8 12.1167 7.99167 12.2375 7.975 12.3625C7.95833 12.4875 7.93333 12.6 7.9 12.7L14.95 16.8C15.2333 16.55 15.55 16.3542 15.9 16.2125C16.25 16.0708 16.6167 16 17 16C17.8333 16 18.5417 16.2917 19.125 16.875C19.7083 17.4583 20 18.1667 20 19C20 19.8333 19.7083 20.5417 19.125 21.125C18.5417 21.7083 17.8333 22 17 22Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function ChatIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3.99967 9.33301H9.33301V7.99967H3.99967V9.33301ZM3.99967 7.33301H11.9997V5.99967H3.99967V7.33301ZM3.99967 5.33301H11.9997V3.99967H3.99967V5.33301ZM1.33301 14.6663V2.66634C1.33301 2.29967 1.46356 1.98579 1.72467 1.72467C1.98579 1.46356 2.29967 1.33301 2.66634 1.33301H13.333C13.6997 1.33301 14.0136 1.46356 14.2747 1.72467C14.5358 1.98579 14.6663 2.29967 14.6663 2.66634V10.6663C14.6663 11.033 14.5358 11.3469 14.2747 11.608C14.0136 11.8691 13.6997 11.9997 13.333 11.9997H3.99967L1.33301 14.6663ZM3.43301 10.6663H13.333V2.66634H2.66634V11.4163L3.43301 10.6663Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function EmojiPlusIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00575 17C6.9047 17 5.86806 16.7917 4.89583 16.375C3.92361 15.9583 3.07292 15.3854 2.34375 14.6562C1.61458 13.9271 1.04167 13.0767 0.625 12.105C0.208333 11.1334 0 10.0952 0 8.99046C0 7.88571 0.208333 6.85069 0.625 5.88542C1.04167 4.92014 1.61458 4.07292 2.34375 3.34375C3.07292 2.61458 3.92231 2.04167 4.89192 1.625C5.86153 1.20833 6.89756 1 8 1C8.51389 1 9.02431 1.04514 9.53125 1.13542C10.0382 1.22569 10.5278 1.36937 11 1.56644V3.22917C10.5278 2.99306 10.0417 2.8125 9.54167 2.6875C9.04167 2.5625 8.52778 2.5 8 2.5C6.19896 2.5 4.66537 3.13354 3.39923 4.40062C2.13308 5.66769 1.5 7.20242 1.5 9.00479C1.5 10.8072 2.13354 12.3403 3.40063 13.6042C4.66769 14.8681 6.20242 15.5 8.00479 15.5C9.80715 15.5 11.3403 14.8669 12.6042 13.6008C13.8681 12.3346 14.5 10.801 14.5 9C14.5 8.4686 14.4375 7.95381 14.3125 7.45563C14.1875 6.95743 14.0069 6.47222 13.7708 6H15.4375C15.6319 6.48611 15.7743 6.97917 15.8646 7.47917C15.9549 7.97917 16 8.48611 16 9C16 10.1024 15.7917 11.1385 15.375 12.1081C14.9583 13.0777 14.3854 13.9271 13.6562 14.6562C12.9271 15.3854 12.0783 15.9583 11.1099 16.375C10.1415 16.7917 9.10679 17 8.00575 17ZM14 4.5V3H12.5V1.5H14V0H15.5V1.5H17V3H15.5V4.5H14ZM10.75 8.25C11.0972 8.25 11.3924 8.12847 11.6354 7.88542C11.8785 7.64236 12 7.34722 12 7C12 6.65278 11.8785 6.35764 11.6354 6.11458C11.3924 5.87153 11.0972 5.75 10.75 5.75C10.4028 5.75 10.1076 5.87153 9.86458 6.11458C9.62153 6.35764 9.5 6.65278 9.5 7C9.5 7.34722 9.62153 7.64236 9.86458 7.88542C10.1076 8.12847 10.4028 8.25 10.75 8.25ZM5.25 8.25C5.59722 8.25 5.89236 8.12847 6.13542 7.88542C6.37847 7.64236 6.5 7.34722 6.5 7C6.5 6.65278 6.37847 6.35764 6.13542 6.11458C5.89236 5.87153 5.59722 5.75 5.25 5.75C4.90278 5.75 4.60764 5.87153 4.36458 6.11458C4.12153 6.35764 4 6.65278 4 7C4 7.34722 4.12153 7.64236 4.36458 7.88542C4.60764 8.12847 4.90278 8.25 5.25 8.25ZM8 13C8.83333 13 9.60069 12.7847 10.3021 12.3542C11.0035 11.9236 11.5556 11.3403 11.9583 10.6042H4.04167C4.44444 11.3403 4.99653 11.9236 5.69792 12.3542C6.39931 12.7847 7.16667 13 8 13Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function PhotoPlusIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 14C1.0875 14 0.734375 13.8531 0.440625 13.5594C0.146875 13.2656 0 12.9125 0 12.5V1.5C0 1.0875 0.146875 0.734376 0.440625 0.440626C0.734375 0.146876 1.0875 0 1.5 0H8V1.5H1.5V12.5H12.5V6H14V12.5C14 12.9125 13.8531 13.2656 13.5594 13.5594C13.2656 13.8531 12.9125 14 12.5 14H1.5ZM11 4.5V3H9.5V1.5H11V0H12.5V1.5H14V3H12.5V4.5H11ZM2.5 11H11.5L8.5 7L6.25 10L4.75 8L2.5 11Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function SendIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1, 6) rotate(15 12 14)">
        <path
          d="M4.75396 13.3664C4.49341 13.5612 4.20992 13.6106 3.90349 13.5146C3.59705 13.4186 3.40124 13.2117 3.31607 12.8939L2.22356 8.8166L8.47765 5.40875L1.35753 5.58451L0.265023 1.50722C0.179854 1.18936 0.245975 0.912276 0.463385 0.675954C0.680774 0.43962 0.950984 0.340654 1.27401 0.379057L16.2778 2.45068C16.68 2.51531 16.9321 2.73775 17.034 3.11798C17.1358 3.49822 17.0285 3.81571 16.7118 4.07044L4.75396 13.3664Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DeleteIcon(props: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6.7565 17.0832C6.38807 17.0832 6.07267 16.952 5.81031 16.6896C5.54794 16.4272 5.41675 16.1118 5.41675 15.7434V5.99984H4.95841C4.80494 5.99984 4.6763 5.94833 4.57248 5.8453C4.46866 5.74227 4.41675 5.6146 4.41675 5.4623C4.41675 5.30999 4.46866 5.18096 4.57248 5.0752C4.6763 4.96942 4.80494 4.91653 4.95841 4.91653H8.00006V4.66653C8.00006 4.48608 8.06392 4.332 8.19164 4.20428C8.31937 4.07656 8.47345 4.0127 8.65389 4.0127H11.3462C11.5267 4.0127 11.6808 4.07656 11.8085 4.20428C11.9362 4.332 12.0001 4.48608 12.0001 4.66653V4.91653H15.0417C15.1952 4.91653 15.3238 4.96805 15.4276 5.07109C15.5315 5.17412 15.5834 5.30179 15.5834 5.45409C15.5834 5.6064 15.5315 5.73543 15.4276 5.8412C15.3238 5.94696 15.1952 5.99984 15.0417 5.99984H14.5834V15.7344C14.5834 16.113 14.4522 16.4324 14.1898 16.6927C13.9274 16.953 13.6121 17.0832 13.2436 17.0832H6.7565ZM8.33662 14.4998H9.41994V7.49984H8.33662V14.4998ZM10.5802 14.4998H11.6635V7.49984H10.5802V14.4998Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg
      width="17"
      height="16"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M11.1449 8.17538L11.3203 7.99719L11.1421 7.82181L6.94207 3.68848L6.76531 3.51452L6.58994 3.68989L6.12327 4.15655L5.9465 4.33333L6.12327 4.51011L9.67983 8.06666L6.12327 11.6232L5.9465 11.8L6.12327 11.9768L6.58994 12.4434L6.76811 12.6216L6.94488 12.442L11.1449 8.17538Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  )
}

export function FireIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5.99997 14C5.99997 15.0077 6.24068 15.9455 6.7221 16.8135C7.20352 17.6814 7.86539 18.3814 8.70773 18.9135C8.63336 18.7725 8.58015 18.6317 8.5481 18.4913C8.51603 18.351 8.5 18.2038 8.5 18.05C8.5 17.5872 8.58878 17.1513 8.76635 16.7423C8.94392 16.3333 9.19872 15.9628 9.53077 15.6308L12 13.202L14.4788 15.6308C14.8109 15.9628 15.064 16.3333 15.2384 16.7423C15.4128 17.1513 15.5 17.5872 15.5 18.05C15.5 18.2038 15.4839 18.351 15.4518 18.4913C15.4198 18.6317 15.3666 18.7725 15.2922 18.9135C16.1346 18.3814 16.7964 17.6814 17.2779 16.8135C17.7593 15.9455 18 15.0077 18 14C18 13.1667 17.8458 12.3792 17.5375 11.6375C17.2291 10.8958 16.7833 10.2333 16.2 9.64999C15.8666 9.86665 15.5166 10.0292 15.15 10.1375C14.7833 10.2458 14.4083 10.3 14.025 10.3C12.9852 10.3 12.0862 9.95832 11.3278 9.27499C10.5695 8.59165 10.1352 7.74358 10.025 6.73076C9.37497 7.27435 8.79997 7.84197 8.29997 8.43364C7.79997 9.0253 7.37914 9.62851 7.03747 10.2433C6.69581 10.858 6.43747 11.482 6.26247 12.1154C6.08747 12.7487 5.99997 13.3769 5.99997 14ZM12 15.3L10.575 16.7C10.3916 16.8833 10.25 17.0917 10.15 17.325C10.05 17.5583 9.99997 17.8 9.99997 18.05C9.99997 18.5833 10.1958 19.0417 10.5875 19.425C10.9791 19.8083 11.45 20 12 20C12.55 20 13.0208 19.8083 13.4125 19.425C13.8041 19.0417 14 18.5833 14 18.05C14 17.7833 13.95 17.5375 13.85 17.3125C13.75 17.0875 13.6083 16.8833 13.425 16.7L12 15.3ZM11.4999 3.89429V6.29999C11.4999 7.00769 11.7439 7.60129 12.2317 8.08079C12.7195 8.56027 13.3173 8.80001 14.025 8.80001C14.3314 8.80001 14.6234 8.74232 14.901 8.62694C15.1785 8.51155 15.4333 8.34169 15.6654 8.11734L16.1058 7.67311C17.1596 8.34746 17.9887 9.24714 18.5932 10.3721C19.1977 11.4971 19.5 12.7064 19.5 14C19.5 16.0923 18.773 17.8654 17.3192 19.3192C15.8653 20.773 14.0923 21.5 12 21.5C9.90767 21.5 8.13461 20.773 6.68077 19.3192C5.22692 17.8654 4.5 16.0923 4.5 14C4.5 12.068 5.12948 10.209 6.38845 8.42311C7.64742 6.63721 9.35125 5.1276 11.4999 3.89429Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TrendingUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M3.4 18L2 16.6L9.4 9.15L13.4 13.15L18.6 8H16V6H22V12H20V9.4L13.4 16L9.4 12L3.4 18Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ThreeDotsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function DrawingTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_3805"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_3805)">
        <path
          d="M8.50023 42C8.07023 42 7.71023 41.86 7.43023 41.57C7.15023 41.29 7.00023 40.93 7.00023 40.5V36.85C7.00023 36.45 7.08023 36.06 7.25023 35.68C7.42023 35.3 7.63023 34.97 7.90023 34.7L35.5502 7.05C35.9202 6.68 36.2902 6.42 36.6702 6.25C37.0502 6.08 37.4602 6 37.8902 6C38.2902 6 38.6802 6.08 39.0702 6.25C39.4602 6.42 39.8302 6.68 40.1902 7.05L41.9402 8.8C42.3102 9.13 42.5702 9.49 42.7402 9.87C42.9102 10.25 42.9902 10.66 42.9902 11.09C42.9902 11.49 42.9102 11.89 42.7402 12.29C42.5702 12.69 42.3102 13.07 41.9402 13.44L14.2902 41.09C14.0202 41.36 13.7002 41.57 13.3102 41.74C12.9202 41.91 12.5402 41.99 12.1302 41.99H8.48023L8.50023 42ZM36.6502 14.55L40.0502 11.15L37.8502 8.95L34.4502 12.35L36.6502 14.55ZM27.0002 42C29.6002 42 31.9202 41.39 33.9502 40.18C35.9802 38.96 37.0002 37.24 37.0002 35C37.0002 33.67 36.5102 32.44 35.5202 31.32C34.5402 30.2 33.0002 29.33 30.9002 28.7L28.5502 31.05C30.2202 31.45 31.5402 32.02 32.5202 32.75C33.5002 33.48 34.0002 34.23 34.0002 35C34.0002 36.07 33.3202 37 31.9802 37.8C30.6302 38.6 28.9702 39 27.0002 39C26.6002 39 26.2502 39.14 25.9502 39.43C25.6502 39.71 25.5002 40.07 25.5002 40.5C25.5002 40.9 25.6502 41.25 25.9502 41.55C26.2502 41.85 26.6002 42 27.0002 42ZM11.0002 27.3L13.4002 24.9C11.6002 24.47 10.2502 24.01 9.35023 23.52C8.45023 23.04 8.00023 22.53 8.00023 21.99C8.00023 21.45 8.36023 20.95 9.07023 20.46C9.79023 19.98 11.2602 19.32 13.5002 18.49C16.2702 17.46 18.1202 16.46 19.0702 15.52C20.0202 14.57 20.5002 13.41 20.5002 12.05C20.5002 10.18 19.8202 8.71 18.4502 7.62C17.0802 6.53 15.2702 6 13.0002 6C11.6002 6 10.3302 6.24 9.20023 6.72C8.07023 7.2 7.22023 7.81 6.65023 8.55C6.38023 8.85 6.26023 9.2 6.27023 9.6C6.29023 10 6.48023 10.33 6.85023 10.6C7.18023 10.87 7.56023 10.98 7.97023 10.93C8.39023 10.88 8.73023 10.72 8.99023 10.45C9.49023 9.95 10.0602 9.58 10.6902 9.35C11.3202 9.12 12.0902 9 12.9902 9C14.5202 9 15.6602 9.3 16.3902 9.9C17.1202 10.5 17.4902 11.22 17.4902 12.05C17.4902 12.72 17.1702 13.3 16.5402 13.8C15.9102 14.3 14.4902 14.95 12.2902 15.75C9.16023 16.88 7.16023 17.92 6.29023 18.85C5.42023 19.78 4.99023 20.83 4.99023 22C4.99023 23.07 5.46023 24.1 6.39023 25.1C7.32023 26.1 8.86023 26.83 10.9902 27.3H11.0002Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CfStudioTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4224"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4224)">
        <path
          d="M43.66 23.53L29.4 18.6L24.47 4.34C24.4 4.14 24.21 4 24 4C23.79 4 23.6 4.14 23.53 4.34L18.59 18.6L4.34 23.53C4.14 23.6 4 23.79 4 24C4 24.21 4.14 24.4 4.34 24.47L18.6 29.4L23.54 43.66C23.61 43.86 23.8 44 24.01 44C24.22 44 24.41 43.86 24.48 43.66L29.42 29.4L43.68 24.47C43.88 24.4 44.02 24.21 44.02 24C44.02 23.79 43.88 23.6 43.68 23.53H43.66Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function TeachingMaterialsTopicIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_5063_4352"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_4352)">
        <path
          d="M43 32.3499V19.7499L25.4 29.2499C24.9333 29.5166 24.45 29.6416 23.95 29.6249C23.45 29.6082 22.9667 29.4666 22.5 29.1999L4.39999 19.2999C4.13333 19.1332 3.94166 18.9412 3.82499 18.7237C3.70833 18.5062 3.64999 18.2645 3.64999 17.9987C3.64999 17.7328 3.70833 17.4916 3.82499 17.2749C3.94166 17.0582 4.13333 16.8666 4.39999 16.6999L22.5 6.7999C22.7289 6.66657 22.9642 6.56657 23.2059 6.4999C23.4476 6.43324 23.6956 6.3999 23.95 6.3999C24.2044 6.3999 24.4524 6.43324 24.6941 6.4999C24.9358 6.56657 25.1711 6.66657 25.4 6.7999L45.2 17.5499C45.454 17.6785 45.6508 17.8649 45.7905 18.1092C45.9302 18.3535 46 18.617 46 18.8999V32.3499C46 32.7749 45.8554 33.1312 45.5662 33.4187C45.2771 33.7062 44.9187 33.8499 44.4912 33.8499C44.0637 33.8499 43.7083 33.7062 43.425 33.4187C43.1417 33.1312 43 32.7749 43 32.3499ZM22.5 41.1999L11 34.8999C10.5333 34.6332 10.1583 34.2624 9.87499 33.7874C9.59166 33.3124 9.44999 32.7999 9.44999 32.2499V23.5499L22.5 30.6999C22.9552 30.9666 23.4356 31.0999 23.9414 31.0999C24.4471 31.0999 24.9333 30.9666 25.4 30.6999L38.45 23.5499V32.2499C38.45 32.7999 38.3083 33.3124 38.025 33.7874C37.7417 34.2624 37.3667 34.6332 36.9 34.8999L25.4 41.1999C25.1711 41.3332 24.9358 41.4332 24.6941 41.4999C24.4524 41.5666 24.2044 41.5999 23.95 41.5999C23.6956 41.5999 23.4476 41.5666 23.2059 41.4999C22.9642 41.4332 22.7289 41.3332 22.5 41.1999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArticleProjectIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '48'}
      height={props.height ?? '48'}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1578_7767"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1578_7767)">
        <path
          d="M2.66671 14C2.30004 14 1.98615 13.8694 1.72504 13.6083C1.46393 13.3472 1.33337 13.0333 1.33337 12.6667V3.33333C1.33337 2.96667 1.46393 2.65278 1.72504 2.39167C1.98615 2.13056 2.30004 2 2.66671 2H13.3334C13.7 2 14.0139 2.13056 14.275 2.39167C14.5362 2.65278 14.6667 2.96667 14.6667 3.33333V12.6667C14.6667 13.0333 14.5362 13.3472 14.275 13.6083C14.0139 13.8694 13.7 14 13.3334 14H2.66671ZM4.00004 11.3333H12V10H4.00004V11.3333ZM4.00004 8.66667H6.66671V4.66667H4.00004V8.66667ZM8.00004 8.66667H12V7.33333H8.00004V8.66667ZM8.00004 6H12V4.66667H8.00004V6Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SettingsIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1096_105464"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1096_105464)">
        <path
          d="M9.24995 22L8.84995 18.8C8.63328 18.7167 8.42912 18.6167 8.23745 18.5C8.04578 18.3833 7.85828 18.2583 7.67495 18.125L4.69995 19.375L1.94995 14.625L4.52495 12.675C4.50828 12.5583 4.49995 12.4458 4.49995 12.3375V11.6625C4.49995 11.5542 4.50828 11.4417 4.52495 11.325L1.94995 9.375L4.69995 4.625L7.67495 5.875C7.85828 5.74167 8.04995 5.61667 8.24995 5.5C8.44995 5.38333 8.64995 5.28333 8.84995 5.2L9.24995 2H14.75L15.15 5.2C15.3666 5.28333 15.5708 5.38333 15.7625 5.5C15.9541 5.61667 16.1416 5.74167 16.325 5.875L19.3 4.625L22.05 9.375L19.475 11.325C19.4916 11.4417 19.5 11.5542 19.5 11.6625V12.3375C19.5 12.4458 19.4833 12.5583 19.45 12.675L22.025 14.625L19.275 19.375L16.325 18.125C16.1416 18.2583 15.95 18.3833 15.75 18.5C15.55 18.6167 15.35 18.7167 15.15 18.8L14.75 22H9.24995ZM11 20H12.975L13.325 17.35C13.8416 17.2167 14.3208 17.0208 14.7625 16.7625C15.2041 16.5042 15.6083 16.1917 15.975 15.825L18.45 16.85L19.425 15.15L17.275 13.525C17.3583 13.2917 17.4166 13.0458 17.45 12.7875C17.4833 12.5292 17.5 12.2667 17.5 12C17.5 11.7333 17.4833 11.4708 17.45 11.2125C17.4166 10.9542 17.3583 10.7083 17.275 10.475L19.425 8.85L18.45 7.15L15.975 8.2C15.6083 7.81667 15.2041 7.49583 14.7625 7.2375C14.3208 6.97917 13.8416 6.78333 13.325 6.65L13 4H11.025L10.675 6.65C10.1583 6.78333 9.67912 6.97917 9.23745 7.2375C8.79578 7.49583 8.39162 7.80833 8.02495 8.175L5.54995 7.15L4.57495 8.85L6.72495 10.45C6.64162 10.7 6.58328 10.95 6.54995 11.2C6.51662 11.45 6.49995 11.7167 6.49995 12C6.49995 12.2667 6.51662 12.525 6.54995 12.775C6.58328 13.025 6.64162 13.275 6.72495 13.525L4.57495 15.15L5.54995 16.85L8.02495 15.8C8.39162 16.1833 8.79578 16.5042 9.23745 16.7625C9.67912 17.0208 10.1583 17.2167 10.675 17.35L11 20ZM12.05 15.5C13.0166 15.5 13.8416 15.1583 14.525 14.475C15.2083 13.7917 15.55 12.9667 15.55 12C15.55 11.0333 15.2083 10.2083 14.525 9.525C13.8416 8.84167 13.0166 8.5 12.05 8.5C11.0666 8.5 10.2375 8.84167 9.56245 9.525C8.88745 10.2083 8.54995 11.0333 8.54995 12C8.54995 12.9667 8.88745 13.7917 9.56245 14.475C10.2375 15.1583 11.0666 15.5 12.05 15.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SettingsFillIcon(props: IconProps) {
  return (
    <svg
      width="14"
      height="14"
      {...props}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3031_1334"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <rect width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3031_1334)">
        <path
          d="M5.35521 12.8337L5.13646 10.9962C5.03924 10.9378 4.93229 10.8746 4.81563 10.8066C4.69896 10.7385 4.59201 10.6753 4.49479 10.617L2.78854 11.3316L1.14062 8.48783L2.59896 7.37949V6.62116L1.14062 5.51283L2.78854 2.66908L4.49479 3.38366C4.59201 3.32533 4.69896 3.26213 4.81563 3.19408C4.93229 3.12602 5.03924 3.06283 5.13646 3.00449L5.35521 1.16699H8.65104L8.86979 3.00449C8.96701 3.06283 9.07396 3.12602 9.19063 3.19408C9.30729 3.26213 9.41424 3.32533 9.51146 3.38366L11.2177 2.66908L12.8656 5.51283L11.4219 6.62116V7.37949L12.8656 8.48783L11.2177 11.3316L9.51146 10.617C9.41424 10.6753 9.30729 10.7385 9.19063 10.8066C9.07396 10.8746 8.96701 10.9378 8.86979 10.9962L8.65104 12.8337H5.35521ZM7.00313 9.08574C7.57674 9.08574 8.06771 8.88158 8.47604 8.47324C8.88438 8.06491 9.08854 7.57394 9.08854 7.00033C9.08854 6.42672 8.88438 5.93574 8.47604 5.52741C8.06771 5.11908 7.57674 4.91491 7.00313 4.91491C6.42951 4.91491 5.93854 5.11908 5.53021 5.52741C5.12188 5.93574 4.91771 6.42672 4.91771 7.00033C4.91771 7.57394 5.12188 8.06491 5.53021 8.47324C5.93854 8.88158 6.42951 9.08574 7.00313 9.08574Z"
          fill="#02CAA9"
        />
      </g>
    </svg>
  )
}

export function ThumbUpFillIcon(props: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      {...props}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g mask="url(#mask0_1096_105524)">
        <path
          d="M10.3461 4.25001C10.584 4.25001 10.794 4.3412 10.9764 4.52358C11.1588 4.70594 11.25 4.91604 11.25 5.15386V5.96154C11.25 6.01346 11.2445 6.06955 11.2336 6.1298C11.2227 6.19006 11.2064 6.24615 11.1846 6.29808L9.7519 9.67883C9.6801 9.83909 9.55991 9.97434 9.39133 10.0846C9.22273 10.1949 9.04741 10.25 8.86536 10.25H4.81729C4.56793 10.25 4.35495 10.1617 4.17835 9.98508C4.00174 9.80848 3.91344 9.5955 3.91344 9.34614V4.62405C3.91344 4.50354 3.93812 4.38768 3.98748 4.27646C4.03683 4.16525 4.10254 4.06861 4.1846 3.98656L6.82979 1.35868C6.92914 1.26445 7.0442 1.20644 7.17496 1.18464C7.30573 1.16285 7.43105 1.1824 7.55093 1.2433C7.67079 1.30419 7.75733 1.39361 7.81053 1.51156C7.86373 1.62951 7.87431 1.75482 7.84226 1.88751L7.3038 4.25001H10.3461ZM2.15385 10.25C1.90449 10.25 1.69151 10.1617 1.51491 9.98508C1.3383 9.80848 1.25 9.5955 1.25 9.34614V5.15386C1.25 4.90451 1.3383 4.69153 1.51491 4.51493C1.69151 4.33832 1.90449 4.25001 2.15385 4.25001H2.25963C2.50898 4.25001 2.72196 4.33832 2.89856 4.51493C3.07516 4.69153 3.16346 4.90451 3.16346 5.15386V9.35095C3.16346 9.60031 3.07516 9.81249 2.89856 9.98749C2.72196 10.1625 2.50898 10.25 2.25963 10.25H2.15385Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FollowIcon(props: IconProps) {
  return (
    <svg
      width="12"
      height="12"
      {...props}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1818_112156"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_1818_112156)">
        <path
          d="M2.5 10.5C2.225 10.5 1.98958 10.4021 1.79375 10.2063C1.59792 10.0104 1.5 9.775 1.5 9.5C1.5 9.225 1.59792 8.98958 1.79375 8.79375C1.98958 8.59792 2.225 8.5 2.5 8.5C2.775 8.5 3.01042 8.59792 3.20625 8.79375C3.40208 8.98958 3.5 9.225 3.5 9.5C3.5 9.775 3.40208 10.0104 3.20625 10.2063C3.01042 10.4021 2.775 10.5 2.5 10.5ZM8.5 10.5C8.5 9.525 8.31667 8.61458 7.95 7.76875C7.58333 6.92292 7.08333 6.18333 6.45 5.55C5.81667 4.91667 5.07708 4.41667 4.23125 4.05C3.38542 3.68333 2.475 3.5 1.5 3.5V2C2.68333 2 3.7875 2.22083 4.8125 2.6625C5.8375 3.10417 6.7375 3.7125 7.5125 4.4875C8.2875 5.2625 8.89583 6.1625 9.3375 7.1875C9.77917 8.2125 10 9.31667 10 10.5H8.5ZM5.5 10.5C5.5 9.94167 5.39583 9.42292 5.1875 8.94375C4.97917 8.46458 4.69167 8.04167 4.325 7.675C3.95833 7.30833 3.53542 7.02083 3.05625 6.8125C2.57708 6.60417 2.05833 6.5 1.5 6.5V5C2.26667 5 2.98125 5.14375 3.64375 5.43125C4.30625 5.71875 4.8875 6.1125 5.3875 6.6125C5.8875 7.1125 6.28125 7.69375 6.56875 8.35625C6.85625 9.01875 7 9.73333 7 10.5H5.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CrossIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width={props.width ?? '40'}
      height={props.height ?? '40'}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="14.71484"
        y="6.73047"
        width="22.2222"
        height="4.44444"
        rx="2.22222"
        transform="rotate(45 9.71484 6.73047)"
        fill="currentColor"
      />
      <rect
        x="25.4277"
        y="4.87305"
        width="22.2222"
        height="4.44444"
        rx="2.22222"
        transform="rotate(135 25.4277 9.87305)"
        fill="currentColor"
      />
    </svg>
  )
}

export function CloseIcon(props: IconProps) {
  return (
    <svg
      width="10"
      height="10"
      {...props}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.4 10.0004L0 8.60039L3.6 5.00039L0 1.42539L1.4 0.0253906L5 3.62539L8.575 0.0253906L9.975 1.42539L6.375 5.00039L9.975 8.60039L8.575 10.0004L5 6.40039L1.4 10.0004Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function TriangleDownIcon(props: IconProps) {
  return (
    <svg
      width="10"
      height="6"
      {...props}
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.833374 0.708313L5.41671 5.29165L10 0.708313H0.833374Z" fill="currentColor" />
    </svg>
  )
}

export function AllAccessIcon(props: IconProps) {
  return (
    <svg
      width="11"
      height="11"
      {...props}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.8 7.8L8.325 4.275L7.625 3.575L4.8 6.4L3.375 4.975L2.675 5.675L4.8 7.8ZM5.5 10.5C4.80833 10.5 4.15833 10.3687 3.55 10.1062C2.94167 9.84375 2.4125 9.4875 1.9625 9.0375C1.5125 8.5875 1.15625 8.05833 0.89375 7.45C0.63125 6.84167 0.5 6.19167 0.5 5.5C0.5 4.80833 0.63125 4.15833 0.89375 3.55C1.15625 2.94167 1.5125 2.4125 1.9625 1.9625C2.4125 1.5125 2.94167 1.15625 3.55 0.89375C4.15833 0.63125 4.80833 0.5 5.5 0.5C6.19167 0.5 6.84167 0.63125 7.45 0.89375C8.05833 1.15625 8.5875 1.5125 9.0375 1.9625C9.4875 2.4125 9.84375 2.94167 10.1062 3.55C10.3687 4.15833 10.5 4.80833 10.5 5.5C10.5 6.19167 10.3687 6.84167 10.1062 7.45C9.84375 8.05833 9.4875 8.5875 9.0375 9.0375C8.5875 9.4875 8.05833 9.84375 7.45 10.1062C6.84167 10.3687 6.19167 10.5 5.5 10.5Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function LinkIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3333 4.66667H8.66658V6.00001H11.3333C12.4333 6.00001 13.3333 6.9 13.3333 8C13.3333 9.1 12.4333 10 11.3333 10H8.66658V11.3333H11.3333C13.1733 11.3333 14.6666 9.84 14.6666 8C14.6666 6.16 13.1733 4.66667 11.3333 4.66667ZM7.33325 10H4.66658C3.56659 10 2.66659 9.1 2.66659 8C2.66659 6.9 3.56659 6.00001 4.66658 6.00001H7.33325V4.66667H4.66658C2.82659 4.66667 1.33325 6.16 1.33325 8C1.33325 9.84 2.82659 11.3333 4.66658 11.3333H7.33325V10ZM5.33325 7.33334H10.6666V8.66667H5.33325V7.33334Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function DeleteTransparentIcon(props: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.6666 6V12.6667H5.33325V6H10.6666ZM9.66658 2H6.33325L5.66659 2.66667H3.33325V4H12.6666V2.66667H10.3333L9.66658 2ZM11.9999 4.66667H3.99992V12.6667C3.99992 13.4 4.59992 14 5.33325 14H10.6666C11.3999 14 11.9999 13.4 11.9999 12.6667V4.66667Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function EmailSettingsIcon(props: IconProps) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_3031_1331"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="50"
        height="50"
      >
        <rect
          x="0.566406"
          y="10.7549"
          width="40"
          height="40"
          transform="rotate(-14.7582 0.566406 10.7549)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_3031_1331)">
        <path
          d="M14.9672 41.4318C14.2241 41.6276 13.5216 41.5325 12.8598 41.1467C12.198 40.7609 11.7693 40.1964 11.5735 39.4533L6.19564 19.0386C5.99987 18.2954 6.0949 17.593 6.48071 16.9312C6.86652 16.2694 7.431 15.8406 8.17415 15.6449L35.0356 8.56876C35.7787 8.37299 36.4812 8.46802 37.143 8.85383C37.8048 9.23964 38.2335 9.80412 38.4293 10.5473L41.8966 23.7094C41.1128 23.5328 40.3235 23.4535 39.5287 23.4714C38.7339 23.4893 37.9425 23.602 37.1546 23.8096C34.4326 24.5266 32.3726 26.0843 30.9744 28.4825C29.5763 30.8807 29.2357 33.4408 29.9527 36.1628L30.2782 37.3984L14.9672 41.4318ZM25.2632 25.9941L36.4508 13.941L35.7432 11.2549L24.5273 23.2006L8.88175 18.331L9.58936 21.0171L25.2632 25.9941Z"
          fill="#5E6370"
        />
      </g>
    </svg>
  )
}

export function Copy06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        id="Icon"
        d="M7.5 3H14.6C16.8402 3 17.9603 3 18.816 3.43597C19.5686 3.81947 20.1805 4.43139 20.564 5.18404C21 6.03969 21 7.15979 21 9.4V16.5M6.2 21H14.3C15.4201 21 15.9802 21 16.408 20.782C16.7843 20.5903 17.0903 20.2843 17.282 19.908C17.5 19.4802 17.5 18.9201 17.5 17.8V9.7C17.5 8.57989 17.5 8.01984 17.282 7.59202C17.0903 7.21569 16.7843 6.90973 16.408 6.71799C15.9802 6.5 15.4201 6.5 14.3 6.5H6.2C5.0799 6.5 4.51984 6.5 4.09202 6.71799C3.71569 6.90973 3.40973 7.21569 3.21799 7.59202C3 8.01984 3 8.57989 3 9.7V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.0799 21 6.2 21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
